import React from "react";
import { FinancialDocumentExtended } from "@common/types/financialDocument";
import styles from "./FinancialDocumentMatches.module.scss";
import { FinancialCounterpartyLink } from "./FinancialCounterpartyLink";

interface Props {
    financialDocument: FinancialDocumentExtended;
}

export const FinancialDocumentCounterpartyLink: React.FC<Props> = ({
    financialDocument,
}) => {
    const { counterparty } = financialDocument;

    if (!counterparty) {
        return null;
    }

    return (
        <section
            className={styles.list}
            data-testid="financial-document-counterparty-link"
        >
            <FinancialCounterpartyLink
                counterparty={counterparty}
                documentCreatedAt={financialDocument.createdAt}
            />
        </section>
    );
};
